import * as t from "../types";

const initialState = {
  data: "",
  loading: false,
  error: "",
};

export function groupAppointmentReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case t.GROUP_APPOINTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case t.GROUP_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.data,
      };
    case t.GROUP_APPOINTMENT_FAILED:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
